import authService from "../../services/authService";

export const authenticateUser = async (type, values) => {
	const service = new authService();
	try {
		if (type === "student") {
			try {
				const data = await service.login(values);
				return data;
			} catch (error) {
				throw new Error(error);
			}
		}
	} catch (error) {
		throw new Error(error);
	}
};

export const refreshToken = async (type) => {
	const service = new authService();
	try {
		if (type === "student") {
			try {
				const { data } = await service.refresh();
				return { data: data };
			} catch (error) {
				throw new Error(error);
			}
		}
	} catch (error) {
		throw new Error(error);
	}
};
